module.exports = __webpack_public_path__ + "static/attivita-5b4f2f34df1fc019b32a7319a3e2f219.jpg";